import { crudService } from '../../../services/api/crudService';
import type { Vendor, VendorInput } from '../types/vendorTypes';

export const vendorService = {
  ...crudService<Vendor, VendorInput>('/vendors'),
  /** Account statement endpoint, used by <LedgerStatement path=… />. */
  ledgerPath: (id: string) => `/vendors/${id}/ledger`,
};
